import React from "react";
import { useMembershipsCatalog } from "../hooks/useMembershipsCatalog";
import "./Memberships.css";
import { Link } from "react-router-dom";
import LoadingSpinner from "./LoadingSpinner";

const Memberships = () => {
  const { data, loading, error } = useMembershipsCatalog();

  if (loading) {
    return <LoadingSpinner className="loading-spinner-container--fullscreen" />;
  }
  if (error) return <p>Could not load memberships. {error}</p>;
  if (!data?.memberships.length) return <p>No memberships available.</p>;

  const membershipList = data.memberships.map((membership) => (
    <Link
      to={`/memberships/${membership.slug}`}
      className="membership-product-item"
      key={membership.contentfulId}
    >
      <img src={membership.coverImage} alt={membership.name} />
      <p>{membership.name}</p>
      <p>{membership.price}kr</p>
    </Link>
  ));

  return (
    <div className="content-container">
      <div className="membership-products-container">
        {membershipList}
      </div>
    </div>
  );
};

export default Memberships;
